import styled from 'styled-components';
  
export const Heading = styled.h1`
   text-align: center;
   color: green;
`;
  
export const Content = styled.div`
   overflow-y: scroll;
   height: 2500px;
`;
  
export const Button = styled.div`
   position: fixed; 
   width: 100%;
   left: 1rem;
   bottom: 1rem;
   font-size: 3rem;
   z-index: 1;
   cursor: pointer;
   color: rgba(0,0,0,0.5);
`